
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/SEO';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="Privatlivspolitik - EquiNord"
        description="Læs om EquiNords privatlivspolitik og hvordan vi håndterer dine personlige oplysninger og cookies."
        keywords="privatlivspolitik, cookies, personlige oplysninger, GDPR, EquiNord"
      />
      <Header />
      <main>
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Privatlivspolitik</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">
              <strong>Senest opdateret:</strong> {new Date().toLocaleDateString('da-DK', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Introduktion</h2>
              <p className="text-gray-700 mb-4">
                EquiNord ("vi", "os", "vores") respekterer dit privatliv og er forpligtet til at beskytte dine personlige oplysninger. 
                Denne privatlivspolitik forklarer, hvordan vi indsamler, bruger og beskytter dine oplysninger, når du besøger vores hjemmeside.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Oplysninger Vi Indsamler</h2>
              <p className="text-gray-700 mb-4">
                Vi indsamler kun de oplysninger, der er nødvendige for at levere vores tjenester:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Tekniske oplysninger (IP-adresse, browser-type, enhedstype)</li>
                <li>Brugsdata (hvilke sider du besøger, hvor længe du opholder dig)</li>
                <li>Cookies og lignende teknologier</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Cookies</h2>
              <p className="text-gray-700 mb-4">
                Vi bruger cookies til at forbedre din oplevelse på vores hjemmeside. Cookies er små tekstfiler, der gemmes på din enhed.
              </p>
              <p className="text-gray-700 mb-4">
                Vi bruger cookies til:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>At huske dine præferencer</li>
                <li>At analysere trafik og brug af hjemmesiden</li>
                <li>At forbedre funktionaliteten</li>
              </ul>
              <p className="text-gray-700 mb-4">
                Du kan til enhver tid slette eller blokere cookies gennem dine browserindstillinger.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Google Analytics</h2>
              <p className="text-gray-700 mb-4">
                Vi bruger Google Analytics til at analysere, hvordan besøgende bruger vores hjemmeside. 
                Dette hjælper os med at forbedre vores tjenester. Google Analytics bruger cookies til at indsamle anonymiseret data.
              </p>
              <p className="text-gray-700 mb-4">
                Du kan læse mere om, hvordan Google håndterer data i deres 
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-emerald-600 hover:text-emerald-700">
                  {' '}privatlivspolitik
                </a>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Dine Rettigheder</h2>
              <p className="text-gray-700 mb-4">
                Under GDPR har du følgende rettigheder:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Ret til at få indsigt i dine personlige oplysninger</li>
                <li>Ret til at få rettet forkerte oplysninger</li>
                <li>Ret til at få slettet dine oplysninger</li>
                <li>Ret til at indvende mod behandling</li>
                <li>Ret til dataportabilitet</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Datasikkerhed</h2>
              <p className="text-gray-700 mb-4">
                Vi implementerer passende tekniske og organisatoriske foranstaltninger for at beskytte dine personlige oplysninger 
                mod uautoriseret adgang, ændring, offentliggørelse eller ødelæggelse.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Kontakt</h2>
              <p className="text-gray-700 mb-4">
                Hvis du har spørgsmål til denne privatlivspolitik eller ønsker at udøve dine rettigheder, kan du kontakte os:
              </p>
              <p className="text-gray-700">
                <strong>Email:</strong> info@equinord.dk<br />
                <strong>Hjemmeside:</strong> <a href="https://equinord.dk" className="text-emerald-600 hover:text-emerald-700">equinord.dk</a>
              </p>
            </section>
          </div>
        </div>
      </div>

      </main>
      <Footer />
    </div>
  );
}

